import { createCachedSelector } from "re-reselect";
import slice from "./slice";

export const selectLoadingCommitById = createCachedSelector(
  slice.selector,
  (state: unknown, commitId: string | undefined) => commitId,
  (state, commitId) =>
    commitId ? (state.loading as Record<string, boolean>)[commitId] : false,
)((state, commitId) => commitId ?? "undefined");
